/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
// import store from '../store'
import cookies from 'js-cookie'
// import { getQueryVariable  } from '@/utils'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: function (resolve) { require(['@/pages/Index'], resolve) } //首页
    },
    {
      path: '/abstract',
      component: function (resolve) { require(['@/pages/searchtools/abstract/Index'], resolve) } //网贷数据(简版)
    },
    {
      path: '/abstract/result',
      component: function (resolve) { require(['@/pages/searchtools/abstract/Result'], resolve) }
    },
    {
      path: '/personalrisk',
      component: function (resolve) { require(['@/pages/searchtools/personalrisk/Index'], resolve) } //个人风险
    },
    {
      path: '/personalrisk/result',
      component: function (resolve) { require(['@/pages/searchtools/personalrisk/Result'], resolve) }
    },
    {
      path: '/personalrisk/result/:nid',
      component: function (resolve) { require(['@/pages/searchtools/personalrisk/Result'], resolve) }
    },
    {
      path: '/vevaluate',
      component: function (resolve) { require(['@/pages/searchtools/car/Index'], resolve) }//车辆估价
    },
    {
      path: '/vevaluate/result',
      component: function (resolve) { require(['@/pages/searchtools/car/Result'], resolve) }
    },
    {
      path: '/vevaluate/result/:nid',
      component: function (resolve) { require(['@/pages/searchtools/car/Result'], resolve) }
    },
    {
      path: '/vevaluate/whyvin',
      component: function (resolve) { require(['@/pages/searchtools/car/whyvin'], resolve) }
    },
    {
      path: '/accurate',
      component: function (resolve) { require(['@/pages/searchtools/accurate/Index'], resolve) }//精准车辆估价
    },
    {
      path: '/accurate/result',
      component: function (resolve) { require(['@/pages/searchtools/accurate/Result'], resolve) }
    },
    {
      path: '/accurate/result/:nid',
      component: function (resolve) { require(['@/pages/searchtools/accurate/Result'], resolve) }
    },
    {
			path: '/illegal',
			component: function (resolve) { require(['@/pages/searchtools/illegal/Index'], resolve) }
		},
		{
      path: '/illegal/result',
      component: function (resolve) { require(['@/pages/searchtools/illegal/Result'], resolve) }
    },
    {
      path: '/illegal/result/:nid',
      component: function (resolve) { require(['@/pages/searchtools/illegal/Result'], resolve) }
    },
    {
      path: '/executor',
      component: function (resolve) { require(['@/pages/searchtools/executor/Index'], resolve) } //被执行人
    },
    {
      path: '/executor/result',
      component: function (resolve) { require(['@/pages/searchtools/executor/Result'], resolve) }
    },
    {
      path: '/executor/result/:nid',
      component: function (resolve) { require(['@/pages/searchtools/executor/Result'], resolve) }
    },
    {
			path: '/carcondition',
			component: function (resolve) { require(['@/pages/searchtools/carcondition/Index'], resolve) }
    },
    {
			path: '/netblack',
			component: function (resolve) { require(['@/pages/searchtools/netblack/Index'], resolve) }
    },
    {
			path: '/netblack/result',
			component: function (resolve) { require(['@/pages/searchtools/netblack/Result'], resolve) }
    },
    {
			path: '/netblack/result/:nid',
			component: function (resolve) { require(['@/pages/searchtools/netblack/Result'], resolve) }
    },
    {
			path: '/lawsuit',
			component: function (resolve) { require(['@/pages/searchtools/lawsuit/Index'], resolve) }
    },
    {
			path: '/lawsuit/result',
			component: function (resolve) { require(['@/pages/searchtools/lawsuit/Result'], resolve) }
    },
    {
			path: '/carcondition',
			component: function (resolve) { require(['@/pages/searchtools/carcondition/Index'], resolve) }
    },
    {
			path: '/carcondition/result',
			component: function (resolve) { require(['@/pages/searchtools/carcondition/Result'], resolve) }
    },
    {
			path: '/carcondition/result/:nid',
			component: function (resolve) { require(['@/pages/searchtools/carcondition/Result'], resolve) }
    },
    {
			path: '/maintain',
			component: function (resolve) { require(['@/pages/searchtools/maintain/Index'], resolve) }
    },
    {
			path: '/maintain/result',
			component: function (resolve) { require(['@/pages/searchtools/maintain/Result'], resolve) }
    },
    {
			path: '/maintain/result/:nid',
			component: function (resolve) { require(['@/pages/searchtools/maintain/Result'], resolve) }
    },
    {
			path: '/maintain/loading',
			component: function (resolve) { require(['@/pages/searchtools/maintain/RequestLoading'], resolve) }
    },
    {
			path: '/maintain/loading/:nid',
			component: function (resolve) { require(['@/pages/searchtools/maintain/RequestLoading'], resolve) }
    },
    {
			path: '/riskevent',
			component: function (resolve) { require(['@/pages/searchtools/losslog/Index'], resolve) }
    },
    {
			path: '/riskevent/result',
			component: function (resolve) { require(['@/pages/searchtools/losslog/Result'], resolve) }
    },
    {
			path: '/riskevent/result/:nid',
			component: function (resolve) { require(['@/pages/searchtools/losslog/Result'], resolve) }
    },
    {
			path: '/riskevent/loading',
			component: function (resolve) { require(['@/pages/searchtools/losslog/RequestLoading'], resolve) }
    },
    {
      path: '/house',
      component: function (resolve) { require(['@/pages/searchtools/house/Index'], resolve) } // 房产估价
    },
    {
      path: '/house/result',
      component: function (resolve) { require(['@/pages/searchtools/house/Result'], resolve) }
    },
    {
      path: '/house/result/:id',
      component: function (resolve) { require(['@/pages/searchtools/house/Result'], resolve) }
    },
		{
      path: '/forbidden',
      component: function (resolve) { require(['@/pages/common/403'], resolve) }
    },
    {
      path: '/agreement',
      component: function (resolve) { require(['@/pages/common/Agreement'], resolve) } //协议
    },
    {
      path: '*',
      component: function (resolve) { require(['@/pages/common/404'], resolve) }
    }
  ]
})
router.beforeEach((to, from, next) => {
  // const channel = cookies.get('channel') || ''
  // const testchannel = 'fd8aacb829f4d8c5e4d7b03f277e179d-channel'
  // const testchannel = 'c10a4f1e7e0ac36161e8629ef0f57880-channel'
  // console.log(11111,to.query)
  if(!!to.query.channel) {
    cookies.set('channel',to.query.channel)
    if(to.query.channel === 'c10a4f1e7e0ac36161e8629ef0f57880-channel') {
      next('/vevaluate')
    }
    next()
  } 
  next()
})
router.afterEach((to, from) => {
  Vue.$vux.toast.hide()
  Vue.$vux.confirm.hide()
	Vue.$vux.loading.hide()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js